import expiredImg from './expiredIcon.svg'

export const expiredIcon = expiredImg;